import Swiper from 'swiper';
import SwiperCore, { Navigation, Scrollbar } from 'swiper/core';
import 'swiper/css';
import './swiper.scss';
SwiperCore.use([Navigation, Scrollbar]);

export default class FeaturedCollectionsSlider {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * featured Collections slider element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.sliderSlides = this.sliderElement.querySelectorAll('.js-swiper-slide');
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');
        this.swiperNav = this.sliderElement.querySelector('.js-swiper-nav');

        this.swiper = new Swiper(this.sliderElement, {
            slidesPerView: 1.3,
            spaceBetween: 20,
            center: true,
            threshold: 10,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    center: false
                },
                1024: {
                    slidesPerView: Math.min(this.sliderSlides.length, 4),
                    center: false
                }
            }
        });

        if (this.swiperNav) {
            this.swiperNav.classList.remove('hidden');
        }
    }
}
